import {
    useEffect,
    useMemo,
} from 'react'
import isNil from 'lodash/isNil'

import DomainObjectForm from 'app/shared-components/DomainObjectForm'
import {
    StorageType,
} from 'app/enums/label.enums'
import useEnumValues from 'app/hooks/useEnumValues'

import {
    StorageTableType,
} from '../../../serviceCenters.types'
import getFields from './StorageForm.fields'
import useStyles from './StorageForm.style'

type StorageFormProps = {
    value?: StorageTableType,
    onChange: (storage: StorageTableType) => void,
}
const defaultProps: Partial<StorageFormProps> = {
    value: {} as StorageTableType,
}

const StorageForm = ({
    value,
    onChange,
}: StorageFormProps) => {
    const {
        classes,
    } = useStyles()
    const getAllowedValues = useEnumValues()

    useEffect(() => {
        if (
            value?.storageType === StorageType.DRY
            && (!isNil(value?.preconditioningCapacity))) {
            onChange({
                ...value,
                preconditioningCapacity: undefined,
            })
        }
    }, [
        onChange,
        value,
        value?.storageType,
    ])

    const fields = useMemo(() => {
        return getFields({
            getAllowedValues,
            storageType: value?.storageType,
        })
    }, [
        getAllowedValues,
        value?.storageType,
    ])

    return (
        <div
            className={classes.root}
        >
            <DomainObjectForm
                name="ServiceCenter"
                value={value}
                fields={fields}
                className={classes.gridWrapper}
                onChange={onChange}
            />
        </div>
    )
}

StorageForm.defaultProps = defaultProps

export default StorageForm
